// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentGroupUploadRequestModel {
    static getAttributeTypeMap() {
        return DocumentGroupUploadRequestModel.attributeTypeMap;
    }
}
DocumentGroupUploadRequestModel.discriminator = undefined;
DocumentGroupUploadRequestModel.additionalProperties = false;
DocumentGroupUploadRequestModel.attributeTypeMap = [
    {
        "name": "documentData",
        "baseName": "documentData",
        "type": "string"
    },
    {
        "name": "documentType",
        "baseName": "documentType",
        "type": "object"
    },
    {
        "name": "coverPageText",
        "baseName": "coverPageText",
        "type": "string"
    },
    {
        "name": "thirdPartyId",
        "baseName": "thirdPartyId",
        "type": "string"
    },
    {
        "name": "documentSequenceNumber",
        "baseName": "documentSequenceNumber",
        "type": "number"
    },
    {
        "name": "totalDocumentsInGroup",
        "baseName": "totalDocumentsInGroup",
        "type": "number"
    },
];
//# sourceMappingURL=documentGroupUploadRequestModel.js.map